export default __webpack_public_path__ + "static/media/11.50e9775e.jpg";